<capra-toast class="progress-toast" type="processing">
  <h4 class="toast-header">Creating dataset from output results...</h4>
  <p class="toast-text">Stay on this page to be notified when the data is ready.</p>
</capra-toast>
